module.exports = __webpack_public_path__ + "static/apple-icon-180x180-58de6a291b82618a652569032acba18a.png";